var map = {
	"./Caffezo/1.png": 30,
	"./Caffezo/2.png": 389,
	"./Caffezo/3.png": 7500,
	"./Caffezo/4.png": 2371,
	"./Caffezo/5.png": 7162,
	"./Caffezo/6.png": 7745,
	"./Caffezo/7.png": 6616,
	"./Caffezo/8.png": 1567,
	"./Management/1.png": 2949,
	"./Management/2.png": 5598,
	"./Management/3.png": 7559,
	"./Management/4.png": 2392,
	"./Management/5.png": 6609,
	"./Management/6.png": 6442,
	"./PocketLinks/1.png": 187,
	"./PocketLinks/2.png": 1856,
	"./PocketLinks/3.png": 3033,
	"./PocketLinks/4.png": 3206,
	"./SiPattina/1.png": 4843,
	"./SiPattina/2.png": 4992,
	"./SiPattina/3.png": 1897,
	"./SiPattina/4.png": 8822,
	"./SiPattina/5.png": 7839,
	"./church/1.png": 8793,
	"./church/2.png": 610,
	"./church/3.png": 2155,
	"./church/4.png": 7348,
	"./modern3d/1.png": 5520,
	"./modern3d/2.png": 923,
	"./modern3d/3.png": 7266,
	"./modern3d/4.png": 6413,
	"./modern3d/5.png": 8932,
	"./modern3d/6.png": 7743,
	"./modern3d/7.png": 2646,
	"./modern3d/8.png": 2449,
	"./nmoney/1.png": 1330,
	"./nmoney/2.png": 7417,
	"./nmoney/3.png": 1168,
	"./nmoney/4.png": 7039,
	"./tozbest/1.png": 1563,
	"./tozbest/2.png": 1712,
	"./tozbest/3.png": 8617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;